module.exports = __webpack_public_path__ + "media/images/whatsapp-logo-e64df1be7cc2505bf1020f3f7b584d5e.png";